module.exports = __webpack_public_path__ + "static/img/linea-etica.a90051c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gobierno-en/linea-etica.jpg
// module id = 4jPn
// module chunks = 0